<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            :optionsButton="optionsButton"
            :items="listagemTipoId"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
          >
          </fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            criarVisualizacao.idtipovisualizacaoparametros === 0
              ? adicionarVisualizacao()
              : editandoVisualizacao()
          "
        >
          <div class="row">
            <div class="col-sm-12">
              <v-select
                :options="listagemTipoApresentacao"
                v-model="tipoApresentacaoResult"
                placeholder="Selecione o tipo"
                label="tipoapresentacao"
                v-if="listagemTipoApresentacao"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!tipoApresentacaoResult"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <input type="hidden" v-model="criarVisualizacao.idtipovisualizacao" />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="criarVisualizacao.nmcampo"
                >Nome do Campo</fccInput
              >
            </div>
            <div class="col-sm-6 text-right">
              <fccInput extraClasses="inputLabel" required v-model="criarVisualizacao.descricao"
                >Descrição</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <div class="labelDiv valor">Valor</div>
            </div>
          </div>
          <div class="row" v-for="listaKey in valoresArray" :key="listaKey.idvalorparametro">
            <div class="col-sm-9">
              <fccInput v-model="listaKey.valor" required extraClasses="inputLabel">
                Adicionar Valor</fccInput
              >
            </div>
            <div class="col-sm-3 innerPage icoSpace text-left">
              <a type="button" @click="deleteCampos(listaKey)"
                ><font-awesome-icon icon="times" size="lg"
              /></a>
            </div>
          </div>
          <div v-if="tipoApresentacaoResult.valores">
            <form autocomplete="off" @submit.prevent="addCamposNot">
              <div class="row innerPage">
                <div class="col-sm-9">
                  <fccInput v-model="newValores" required extraClasses="inputLabel">
                    Adicionar Valor</fccInput
                  >
                </div>
                <div class="col-sm-3 innerPage icoSpace text-left">
                  <button
                    type="submit"
                    class="buttonTransparente"
                    v-b-tooltip.hover.right
                    title="Adicionar Campo"
                  >
                    <font-awesome-icon icon="plus" size="lg" />
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-sm-12">
                <fccInput v-model="valores" required extraClasses="inputLabel">
                  Adicionar Valor</fccInput
                >
              </div>
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
      <fccModal
        centered
        idModal="editFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form autocomplete="off" @submit.prevent="editandoVisualizacao">
          <div class="row">
            <div class="col-sm-12">
              <v-select
                :options="listagemTipoApresentacao"
                v-model="tipoApresentacaoResult"
                placeholder="Selecione o tipo"
                label="tipoapresentacao"
                v-if="listagemTipoApresentacao"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!tipoApresentacaoResult"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <input type="hidden" v-model="criarVisualizacao.idtipovisualizacao" />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="criarVisualizacao.nmcampo"
                >Nome do Campo</fccInput
              >
            </div>
            <div class="col-sm-6 text-right">
              <fccInput extraClasses="inputLabel" required v-model="criarVisualizacao.descricao"
                >Descrição</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <div class="labelDiv valor">Valor</div>
            </div>
          </div>
          <div class="row innerPage" v-for="valor in valoresArray" :key="valor.idvalorparametro">
            <div class="col-sm-8">
              <fccInput v-model="valor.valor" extraClasses="inputLabel">
                {{ criarVisualizacao.descricao }}</fccInput
              >
            </div>
            <div
              class="col-sm-1 innerPage icoSpace text-left"
              v-if="tipoApresentacaoResult.valores"
            >
              <a
                type="button"
                @click="deleteCampos(valor)"
                v-b-tooltip.hover.right
                title="Excluir Campo"
                ><font-awesome-icon icon="times" size="lg"
              /></a>
            </div>
            <div class="col-sm-3 innerPage icoSpace">
              <toggle-button v-model="valor.ativo" :sync="true" /> Ativo
            </div>
          </div>
          <form
            autocomplete="off"
            @submit.prevent="addCampos"
            v-if="tipoApresentacaoResult.valores"
          >
            <div class="row innerPage">
              <div class="col-sm-8">
                <fccInput v-model="newValores" required extraClasses="inputLabel">
                  Adicionar Valor</fccInput
                >
              </div>
              <div class="col-sm-4 innerPage icoSpace text-left">
                <button
                  type="submit"
                  class="buttonTransparente"
                  v-b-tooltip.hover.right
                  title="Adicionar Campo"
                >
                  <font-awesome-icon icon="plus" size="lg" />
                </button>
              </div>
            </div>
          </form>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Visualização de Parâmetros',
      titleModal: '',
      itemPorPage: '100',
      tipoId: '',
      tipoApresentacaoResult: '',
      listagemTipoId: [],
      baseUrlGestaoForm: '',
      valores: '',
      newValores: '',
      valoresArray: [],
      criarVisualizacao: {},
      listagemTipoApresentacao: '',
      fields: [
        { key: 'nmcampo', label: 'Nome', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: true },
        { key: 'tipoapresentacao', label: 'Tipo' },
        { key: 'actions', label: '' }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editCampoField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteCampoField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      optionsButton: [
        { funcaoButton: 'voltarField', tooltip: 'Voltar', icon: 'chevron-left' },
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  methods: {
    listarTipoVisualizacaoPorId: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoForm +
            'TVisualizacaoParametros/ListarTipoVisualizacaoPorId/' +
            this.tipoId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemTipoId = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deleteCampos: function (item) {
      if (this.valoresArray.length > 1) {
        this.callConfirm(this.mensagemExcluir, item.valor).then((result) => {
          if (result.value) {
            axios
              .delete(
                this.baseUrlGestaoForm +
                  'TVisualizacaoParametrosValor/Excluir/' +
                  item.idvalorparametro,
                this.dadosLoginSession.fccTokenHeaders
              )
              .then(() => {
                this.listarTipoVisualizacaoPorId()
                this.valoresArray = this.arrayRemove(this.valoresArray, item)
                this.callToast(this.mensagensUpdate.excluido, 'success')
              })
              .catch((error) => {
                this.setErrorSystem(error)
              })
          }
        })
      } else {
        this.callAlert('Erro ao Excluir', 'Necessário ter um valor como padrão', 'error', 'error')
      }
    },
    addCamposNot: function () {
      var number = this.valoresArray.length + 1
      this.valoresArray.push({
        idvalorparametro: number,
        valor: this.newValores,
        ativo: true
      })
      this.newValores = ''
    },
    addCampos: function () {
      var criandoCampo = {
        idvalorparametro: 0,
        idtipovalorparametros: this.criarVisualizacao.idtipovisualizacaoparametros,
        valor: this.newValores,
        ativo: true
      }
      axios
        .post(
          this.baseUrlGestaoForm + 'TVisualizacaoParametrosValor/AdicionarValor',
          criandoCampo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.valoresArray.push({
            idvalorparametro: response.data,
            idtipovalorparametros: this.criarVisualizacao.idtipovisualizacaoparametros,
            valor: this.newValores,
            ativo: true
          })
          this.newValores = ''
          this.listarTipoVisualizacaoPorId()
        })
        .catch(this.setErrorSystem)
    },
    listarTipoApresentacao: function () {
      axios
        .get(
          this.baseUrlGestaoForm + 'CampoTipoApresentacao/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemTipoApresentacao = response.data
        })
        .catch(this.setErrorSystem)
    },
    voltarField: function () {
      this.$router.push({ path: '/publicacoes/tipovisualizacao' })
    },
    deleteCampoField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.nmcampo).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlGestaoForm +
                'TVisualizacaoParametros/ExcluirTipoVisualizacao/' +
                item.idtipovisualizacaoparametros,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoVisualizacaoPorId()
              this.callToast(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editCampoField: function (actions, items) {
      this.valoresArray = []
      this.criarVisualizacao = items
      var status = this.listagemTipoApresentacao.find(
        (element) => element.idtipoapresentacao === items.idtipoapresentacao
      )
      this.tipoApresentacaoResult = {
        idtipoapresentacao: items.idtipoapresentacao,
        tipoapresentacao: items.tipoapresentacao,
        valores: status.valores
      }
      this.valoresArray = items.valores
      this.titleModal = 'Editar Tipo de Visualização'
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    addField: function () {
      this.criarVisualizacao = {}
      this.tipoApresentacaoResult = []
      this.valores = ''
      this.valoresArray = []
      this.criarVisualizacao.idtipovisualizacaoparametros = 0
      this.criarVisualizacao.idtipovisualizacao = this.tipoId
      this.titleModal = 'Adicionar Parâmetro'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editandoVisualizacao: function () {
      var valores = []
      for (var listArray of Object.values(this.valoresArray)) {
        valores.push({
          idvalorparametro: listArray.idvalorparametro,
          idtipovisualizacaoparametros: this.criarVisualizacao.idtipovisualizacaoparametros,
          valor: listArray.valor,
          ativo: listArray.ativo
        })
      }
      if (valores.length > 0) {
        let criarCampo = {
          idtipovisualizacaoparametros: this.criarVisualizacao.idtipovisualizacaoparametros,
          idtipovisualizacao: this.criarVisualizacao.idtipovisualizacao,
          nmcampo: this.criarVisualizacao.nmcampo,
          descricao: this.criarVisualizacao.descricao,
          valor: this.criarVisualizacao.descricao,
          idtipoapresentacao: this.tipoApresentacaoResult.idtipoapresentacao,
          tipoapresentacao: this.tipoApresentacaoResult.tipoapresentacao,
          valores
        }
        axios
          .put(
            this.baseUrlGestaoForm + 'TVisualizacaoParametros/AlterandoTipoVisualizacao',
            criarCampo,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarTipoVisualizacaoPorId()
            this.callToast(this.mensagensUpdate.editado, 'success')
            this.$root.$emit('bv::hide::modal', 'editFieldModal')
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      } else {
        this.callAlert('Erro ao Inserir', 'Favor inserir um valor', 'error', 'error')
      }
    },
    adicionarVisualizacao: function () {
      var valores = []
      if (this.tipoApresentacaoResult.valores) {
        for (var listArray of Object.values(this.valoresArray)) {
          valores.push({
            idvalorparametro: 0,
            idtipovisualizacaoparametros: 0,
            valor: listArray.valor,
            ativo: true
          })
        }
      } else {
        valores = [
          {
            idvalorparametro: 0,
            idtipovisualizacaoparametros: 0,
            valor: this.valores,
            ativo: true
          }
        ]
      }
      if (valores.length > 0) {
        let criarCampo = {
          idtipovisualizacaoparametros: 0,
          idtipovisualizacao: this.criarVisualizacao.idtipovisualizacao,
          nmcampo: this.criarVisualizacao.nmcampo,
          descricao: this.criarVisualizacao.descricao,
          valor: this.criarVisualizacao.descricao,
          idtipoapresentacao: this.tipoApresentacaoResult.idtipoapresentacao,
          tipoapresentacao: this.tipoApresentacaoResult.tipoapresentacao,
          valores
        }
        axios
          .post(
            this.baseUrlGestaoForm + 'TVisualizacaoParametros/AdicionarTipoVisualizacao',
            criarCampo,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarTipoVisualizacaoPorId()
            this.callToast(this.mensagensUpdate.editado, 'success')
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      } else {
        this.callAlert('Erro ao Inserir', 'Favor inserir um valor', 'error', 'error')
      }
    }
  },
  mounted: function () {
    this.tipoId = this.$route.params.id
    this.baseUrlGestaoForm = store.state.baseUrlGestaoForm
    this.listarTipoVisualizacaoPorId()
    this.listarTipoApresentacao()
  }
}
</script>
